module.exports = __webpack_public_path__ + "static/media/team-rocket-1-alt.48b8c61e.wav";